import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'language-dropdown-component',
  templateUrl: './language-dropdown.component.html',
})
export class LanguageDropdownComponent implements AfterViewInit {
  isOpenLangMenu = false;
  langDatasArry = [];
  langDatas;
  constructor(public _LocalizationService: LocalizationService) {}

  ngAfterViewInit(): void {
    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
  }

  selectionChange(x) {
    this._LocalizationService.changeLang(x);
    this.isOpenLangMenu = !this.isOpenLangMenu;
  }

  toggleLanguageMenu() {
    this.isOpenLangMenu = !this.isOpenLangMenu;
  }
}
